import OtherUserDashboardPage from '@/modules/dashboard/metrix/other-user-dashboard-page/other-user-dashboard-page';
import { UserStatsDashboardProvider } from '@/utils/stats/dashboard-context';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/metrix/$userId/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { userId } = Route.useParams();

  return (
    <UserStatsDashboardProvider userId={userId}>
      <OtherUserDashboardPage userId={userId} />
    </UserStatsDashboardProvider>
  );
}
